module.exports = __webpack_public_path__ + "assets1763535487631/img/lan2.eddb60b0.png";